/**
 * @author lifei
 * 功能： actions,
 *  1. options 参数暂不启用，需要重新规划
 */
import { kebabCase, forEach } from 'lodash-es'
import { Cache } from '@/tools'
import * as ENUM from '@/enum'

export class Common<T extends TCommon.TStore.State> {
  /**
   * 功能：处理 oss
   */
  oss = () => {
    // oss
    // Cache.OSS.setItem({}, { expired: new Date() })
  }

  /**
   * 功能：切换业务组
   */
  switchBus = (rootState: T, busId: string) => {
    rootState.sBusId = busId
    Cache.BUS_ID.setItem(busId)
    return Promise.resolve(busId)
  }

  /**
   * 功能：修改 css 默认属性
   */
  private modifyCssVars = (sTheme: TCommon.EnumVal<typeof ENUM.COMMON.MapTheme>) => {
    forEach(ENUM.COMMON.Theme[sTheme], (value, key) => {
      document.documentElement.style.setProperty(`--${kebabCase(key)}`, value)
    })
  }

  /**
   * 功能：更换主题
   */
  switchTheme = (rootState: T): Promise<void> => {
    const { sTheme } = rootState
    rootState.sTheme = sTheme == 'default' ? 'dark' : 'default'
    this.modifyCssVars(rootState.sTheme)
    return new Promise((resolve) => {
      Cache.THEME.setItem(rootState.sTheme)
      resolve()
    })
  }

  /**
   * 功能：获取当前主题色
   */
  getTheme = (rootState: T): Promise<string> => {
    const theme = Cache.THEME.getItem() || rootState.sTheme
    rootState.sTheme = theme
    this.modifyCssVars(rootState.sTheme)
    Cache.THEME.setItem(rootState.sTheme)
    return Promise.resolve(theme)
  }
  /**
   * 功能：添加需要缓存的页面
   */

  addKeepAliveKeys = (rootState: T, key: string): Promise<string[]> => {
    const keys = rootState.sKeepAliveKeys?.includes(key) ? rootState.sKeepAliveKeys : [...rootState.sKeepAliveKeys, key]
    rootState.sKeepAliveKeys = keys
    Cache.KEEP_ALIVE_KEYS.setItem(keys)
    return Promise.resolve(keys)
  }
  /**
   * 功能：添加需要缓存的页面
   */
  removeKeepAliveKeys = (rootState: T, key: string): Promise<string[]> => {
    const keys = rootState?.sKeepAliveKeys?.filter((item) => item !== key)
    rootState.sKeepAliveKeys = keys || Cache.KEEP_ALIVE_KEYS.getItem()
    Cache.KEEP_ALIVE_KEYS.setItem(keys)
    return Promise.resolve(keys)
  }
  /**
   * 功能：获取需要缓存的页面
   */
  getKeepAliveKeys = (rootState: T, key: string): Promise<string[]> => {
    const keys = rootState.sKeepAliveKeys
    rootState.sKeepAliveKeys = keys
    Cache.KEEP_ALIVE_KEYS.setItem(keys)
    return Promise.resolve(keys)
  }
}
